module.exports = __webpack_public_path__ + "static/media/easy-book.de9ac776.svg";